import PageBuilder from 'components/Layout/content/PageBuilder';
import { schemaMarkupGenerator } from 'core/seo';
import { NextPage } from 'next';
import React from 'react';
import { Page } from 'src/types/sanity/new-schema';
import { getPageBySlug } from 'utils/sanity/api';
import ContactUs from '../components/form/ContactUs';
import Meta from '../components/Layout/Meta';
import { DefaultSection } from '../components/styles/Defaults';
import ContentListTemplate from '../components/templates/ContentListTemplate';
import { defaultMetaTags } from '../core/constants';
import content from '../public/content/_faq.json';

const { deliveries, opener, ordering, covid19, visiting, refunds } = content;
interface Props {
    pageData: Page;
}
const FAQPage: NextPage<Props> = ({ pageData }) => {
    return (
        <>
            <Meta
                tags={defaultMetaTags}
                structuredData={schemaMarkupGenerator({
                    data: [deliveries, ordering, covid19, visiting, refunds],
                    schemaType: 'FAQPage',
                })}
            />
            <>{pageData?.pageBuilder && <PageBuilder sections={pageData?.pageBuilder} />}</>
            <>
                <DefaultSection>
                    <ContentListTemplate style="faq" contentObj={covid19} />
                    <ContentListTemplate style="faq" contentObj={visiting} />
                    <ContentListTemplate style="faq" contentObj={deliveries} />
                    <ContentListTemplate style="faq" contentObj={ordering} />
                    <ContentListTemplate style="faq" contentObj={refunds} />
                </DefaultSection>
                <ContactUs isHidden />
            </>
        </>
    );
};

export async function getStaticProps({ preview = false }) {
    const pageData: Page = await getPageBySlug('faq');

    return {
        props: {
            pageData: pageData || null,
            revalidate: 60 * 60,
        },
    };
}

export default FAQPage;
